import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const DEFAULTS = {
  brandName: "AMOR",
  tagline: "AMOR EDITION",
  whatsapp: "972538256594",
  whatsappDisplay: "053-825-6594",
  email: "amor.official@gmail.com",
  instagram: "https://www.instagram.com/",
  shippingText: "FREE SHIPPING OVER ₪400",
  heroVideo: "/hero.mp4",
  heroPoster: "/hero-poster.jpg",
  editorialImage: "",
  editorialText: "DESIGNED TO BE LOVED",
  instagramImages: [],
};

const SettingsContext = createContext({ settings: DEFAULTS, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = async () => {
    try {
      const data = await api.getSettings();
      setSettings({ ...DEFAULTS, ...data });
    } catch (e) {
      // keep defaults
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);

export const CATEGORIES = [
  { slug: "shirts", name: "SHIRTS" },
  { slug: "pants", name: "PANTS" },
  { slug: "shorts", name: "SHORTS" },
  { slug: "tops", name: "TOPS" },
  { slug: "sets", name: "SETS" },
];
